import { createAction, props } from '@ngrx/store';


export const loadCurrentUser = createAction('[User] Load current user');
export const updateCurrentUser = createAction('[User] Update current user', props<{user: any}>());
export const loadCurrentUserSuccess = createAction('[User] Load current user success', props<{user: any}>());